import styled from "styled-components";

export const MainPodcastsListWrapper = styled.div`
  ul {
    grid-template-columns: 1fr 1fr;

    grid-template-columns: ${({ columns }) =>
      columns === 1 ? "1fr" : "1fr 1fr"};

    row-gap: 25px;
    column-gap: 20px;

    @media (max-width: 545px) {
      grid-template-columns: 1fr;
    }
  }
`;

export const PodcastSkeletons = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 25px;
  column-gap: 20px;

  @media (max-width: 880px) {
    grid-template-columns: 1fr;
  }
`;

export const PodcastSkeleton = styled.span`
  min-height: 64px;
  max-height: 120px;
  aspect-ratio: 1/1.35;
`;
